import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import { PAGE_TYPE, setPageTitle } from "containers/App/reducer";

import queryString from "query-string";

import UnifiedProject from "components/UnifiedProject/UnifiedProject";
import CreatingExecutorModal from "containers/Deployments/CreatingExecutorModal";

import ProjectContainer from "containers/Project/Project";

import * as unifiedProjectReducer from "containers/UnifiedProject/reducer";
import * as projectReducer from "containers/Project/reducer";
import * as globalReducer from "containers/App/reducer";
import * as wizardReducer from "containers/Wizard/reducer";
import * as setupReducer from "containers/Setup/reducer";
import * as loginReducer from "containers/Login/reducer";
import * as runReducer from "containers/Run/reducer";

const getId = (props) =>
  props && props.id
    ? props.id
    : props.match && props.match.params && props.match.params.id
      ? props.match.params.id
      : "new";

const getNextId = (props) =>
  props && props.nextId
    ? props.nextId
    : props.match && props.match.params && props.match.params.nextId
      ? props.match.params.nextId
      : "new";

class UnifiedProjectContainer extends React.PureComponent {
  constructor(props) {
    super(props);

    props.init(props.blueprintId, props.datasetId);
  }

  /*
  componentDidUpdate(prevProps) {
    const {
      id,
      optimized,
      hasConstraints,
      modelCount,
      hasJob,
      init,
      resetBudget,
      isDone,
      match,
    } = this.props;

    if (prevProps.id !== id) {
      init(props.blueprintId, props.datasetId);
    }

    // Hacky way to set the budget when model updates
    if (
      modelCount !== prevProps.modelCount &&
      hasJob &&
      ((isDone !== true || prevProps.isDone !== true) &&
        prevProps.hasJob === true)
    ) {
      resetBudget(true);
    }
  }
  */

  componentDidMount() {
    const id = getId(this.props);

    setPageTitle(PAGE_TYPE.PROJECT, id);
  }

  componentDidUpdate(prevProps) {
    const currId = getId(this.props);
    const prevId = getId(prevProps);

    if (currId !== prevId) {
      setPageTitle(PAGE_TYPE.PROJECT, currId);
    }
  }

  componentWillUnmount() {
    const { updateCurrentProjectId, resetDatasetOutcome, updateIsEditBlueprint, reset } = this.props;
    //reset();

    resetDatasetOutcome();
    return updateCurrentProjectId(undefined);
  }

  render() {
    const { isTableauMode, id, nextId } = this.props;

    if (isTableauMode) {
      return <ProjectContainer id={id} nextId={nextId} />;
    }

    return (
      <React.Fragment>
        <CreatingExecutorModal />
        <UnifiedProject {...this.props} isDataSelect />
      </React.Fragment>
    );
  }
}

/*
      hasSplits,
      compareScenarioIndex,
      updateCompareScenarioIndex,
      removeShortlist,
      isAFO,
      refresh,
      aibleViewType,
      viewingScenarioIndex,
      canEditSegments,
*/

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = getId(ownProps);

  return {
    init: (blueprintId, datasetId) => dispatch(unifiedProjectReducer.init(id, blueprintId, datasetId)),
    updateCurrentStep: (stepId) => dispatch(unifiedProjectReducer.updateCurrentStep(id, stepId)),

    resetBudget: (skipShowLoading) => dispatch(projectReducer.resetBudget(id, false, skipShowLoading)),
    resetDatasetOutcome: () => dispatch(projectReducer.resetDatasetOutcome(id)),
    updateCurrentProjectId: (newId) => dispatch(globalReducer.updateCurrentProjectId(newId)),

    deploy: () => dispatch(projectReducer.deploy(id)),

    rerunSegment: (segmentId) => dispatch(projectReducer.rerunSegment(id, segmentId)),

    viewScenario: (scenario, index) => dispatch(projectReducer.viewScenario(id, scenario, index)),
    viewAllScenarios: () => dispatch(projectReducer.viewAllScenarios(id)),
    deleteScenario: () => dispatch(projectReducer.deleteScenario(id)),
    saveScenario: (name) => dispatch(projectReducer.saveScenario(id, name)),
    shortlistScenario: () => dispatch(projectReducer.shortlistScenario(id)),
    removeShortlist: () => dispatch(projectReducer.removeShortlist(id)),
    updateShowShortListed: (val) => dispatch(projectReducer.updateShowShortListed(id, val)),
    updateShowPending: (val) => dispatch(projectReducer.updateShowPending(id, val)),

    updateCompareScenarioIndex: (index) => dispatch(projectReducer.updateCompareScenarioIndex(id, index)),

    trainAI: (options) =>
      dispatch(unifiedProjectReducer.startModelRun(ownProps.id, ownProps.runId, ownProps.blueprintId, options)),

    updateIsEditBlueprint: (label) => dispatch(unifiedProjectReducer.updateIsEditBlueprint(id, label)),
    saveBlueprint: (isApply) => dispatch(unifiedProjectReducer.saveBlueprint(id, isApply)),
    updateLabel: (label) => {
      dispatch((dispatch, getState) => {
        const isEditBlueprint = unifiedProjectReducer.getIsEditBlueprint(getState(), id);

        const innerId = projectReducer.getInnerId(getState(), id);
        const runId = innerId !== undefined ? innerId : isEditBlueprint ? "editBlueprint" : id;
        return dispatch(setupReducer.updateLabel(runId, label));
      });
    },
    reset: () => dispatch(unifiedProjectReducer.reset(id)),
    retrainRun: () => dispatch(projectReducer.retrainRun(id)),
    exportToPowerpoint: () => dispatch(projectReducer.exportToPowerpoint(id))
  };
};

const mapStateToProps = (state, ownProps) => {
  const id = getId(ownProps);
  const nextId = getNextId(ownProps);
  const queryParams = ownProps.location.search;
  const paramsObj = queryParams ? queryString.parse(queryParams) : undefined;

  const type = wizardReducer.STEP_TYPE.ACADEMIC_CHOOSE_DATASET.id;

  const wStep =
    Object.keys(wizardReducer.STEP_TYPE).filter((s) => wizardReducer.STEP_TYPE[s].id === type).length > 0
      ? Object.keys(wizardReducer.STEP_TYPE)
          .filter((s) => wizardReducer.STEP_TYPE[s].id === type)
          .map((s) => wizardReducer.STEP_TYPE[s])[0]
      : undefined;

  const optimized = projectReducer.getOptimized(state, id);
  const isEditBlueprint = unifiedProjectReducer.getIsEditBlueprint(state, id);

  const runId =
    optimized && optimized.innerId !== undefined ? optimized.innerId : isEditBlueprint ? "editBlueprint" : id;

  const blueprintId =
    paramsObj && paramsObj.blueprint ? paramsObj.blueprint : unifiedProjectReducer.getBlueprintId(state, id);

  const datasetId = paramsObj && paramsObj.dataset ? paramsObj.dataset : undefined;

  const isChatStyle = paramsObj && paramsObj.isChatStyle === "true" ? true : undefined;

  return {
    id: id,
    nextId: nextId,
    isChatStyle: isChatStyle,
    isError: projectReducer.getIsError(state, id, runId),
    isTraining: projectReducer.getIsTraining(state, id),
    isProjectNotFound: unifiedProjectReducer.getIsProjectNotFound(state, id),
    blueprintId: blueprintId,
    blueprint: setupReducer.getBlueprintFromSetup(state, runId),
    isForecast: setupReducer.getIsForecast(state, runId),
    forecastMode: setupReducer.getForecastModeH(state, runId),
    forecastTimeCol: setupReducer.getForecastTimeCol(state, runId),

    datasetId: datasetId,
    optimized: optimized,
    currentStep: unifiedProjectReducer.getCurrentStep(state, id),
    hasSplits: projectReducer.getHasSplits(state, id),
    modelCount: projectReducer.getTotalModelCount(state, id),

    hasJob: Object.keys(runReducer.getJob(state, runId)).length > 0,

    isDone: runReducer.getIsDone(state, runId),

    userName: loginReducer.getUserName(state),

    selectedScenario: projectReducer.getSelectedScenario(state, id),
    allScenarios: projectReducer.getAllScenarios(state, id),
    approvedScenario: projectReducer.getApprovedScenario(state, id, runId),
    showShortListed: projectReducer.getShowShortListed(state, id),
    showPending: projectReducer.getShowPending(state, id),
    modelGroups: projectReducer.getModelGroups(state, id),
    project: projectReducer.getProject(state, id),
    optimizer: projectReducer.getOptimizer(state, id),

    isLoadingCompare: projectReducer.getIsLoadingCompare(state, id),

    isTableauMode: ownProps.isTableauMode ? ownProps.isTableauMode : globalReducer.getIsTableauMode(state),

    isAudit: unifiedProjectReducer.getIsAudit(state, id),

    viewingScenarioIndex: projectReducer.getViewingScenarioIndex(state, id),
    compareScenarioIndex: projectReducer.getCompareScenarioIndex(state, id),

    isNextEnabled:
      wStep === undefined || wStep.isEnabled === undefined ? true : wStep.isEnabled(state, { ...ownProps, id: "new" }),

    setup: setupReducer.getSetup(state, runId),

    isEditBlueprint: isEditBlueprint,
    editBlueprintId: unifiedProjectReducer.getEditBlueprintRunId(state, id),
    isSavingBlueprint: unifiedProjectReducer.getIsSavingBlueprint(state, id),
    hasLoadedAllJobs: projectReducer.hasLoadedAllJobs(state, id),
    areJobsInSync: projectReducer.getAreJobsInSync(state, id, runId),
    isRetraining: projectReducer.getIsRetraining(state, id),
    hasSetupIgnoreChanged:
      optimized && optimized.innerId !== undefined ? setupReducer.getSetupIgnoreChanged(state, runId) : false
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(UnifiedProjectContainer);
